import React from 'react';
import PropTypes from 'prop-types';
import * as Api from 'utils/api/api.js';
import {PopUp} from './PopUp.component';
import Comment from '../input/Comment.component';
import UserSearch from '../input/UserSearch.component'
import {TASK_ACTIONS} from 'utils/constants';
import ErrorDialog from './ErrorDialog.component';
import translate from '../translations/translations.wrapper.jsx';
import HandleTask from "components/popup/HandleTask.js";
import { Button, ButtonType } from "components/common/Button.component";
import {FormField} from "components/common/FormField.component";


//this is to make sure the tabbing stays inside the dialog
const TAB_INDEX = 1000;

export class SendForward extends PopUp {
    constructor(props) {
        super(props);
        this.ok = this.ok.bind(this);
        this.buildContent = this.buildContent.bind(this);
        this.focusFirst = this.focusFirst.bind(this);
        this.state = {
            comment: '',
            recipient: null,
            actionRunning: false,
            displayError: null,
            refresh: null,
            isHandled: false
        };

        this._handle = this._handle.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    focusFirst() {
        this.setState({
            refresh: true
        });
    }

    ok() {
        const self = this;
        if (this.state.comment && this.state.recipient && this.state.recipient.value) {
            this.setState({actionRunning: true});

            const key = this.props.tasks.map(task => task.key);
            Api.OverviewReassign(key, this.state.comment, this.state.recipient.value).then(function (response) {
                    self.props.showNotification(response.message);
                    self._handle();
                    self.props.closeCallback();
                },
                function (error) {
                    self.setState({displayError: error});
                });
        }
    }
    _handle() {
        this.setState({
            isHandled: true
        });
    }

    buildContent() {

        const okEnabled = this.state.comment && this.state.recipient && !this.state.actionRunning;
        const keys = this.props.tasks.map(task => task.key);
        return (
            <div>
                {this.state.displayError && <ErrorDialog
                    error={this.state.displayError}
                    closeCallback={() => this.setState({actionRunning: false, displayError: null})}
                    translate={this.props.translate}
                />}
                {this.state.isHandled &&
                    <HandleTask key={this.props.tasks.map(task => task.key)}/>
                }
                <div className="modal-body ast_send_reassign">
                    <FormField
                        id="recipient"
                        label={this.props.translate("popUp.forward.recipient")}
                        labelState={`(${this.props.translate("popUp.required")})`}
                    >
                        <UserSearch ref="recipientInput"
                                    tabindex={TAB_INDEX}
                                    taskId={keys}
                                    translate={this.props.translate}
                                    refresh={this.state.refresh}
                                    propagateValue={ value => this.setState({recipient: value})}
                                    placeholder={this.props.translate("userSearch.placeholder")}
                                    value={this.state.recipient}
                                    includeSameUser={true}
                                    releaseFocus={()=>{this.setState({refresh:false})}}
                                    menuPosition={"fixed"}
                                    menuPortalTarget={document.body}
                        />
                    </FormField>
                    <Comment id="comment"
                             inputHint={this.props.translate("popUp.forward.commentHint")}
                             translate={this.props.translate}
                             tabIndex={TAB_INDEX+1}
                             propagateValue={value => this.setState({comment: value,refresh:false})}
                             value={this.state.comment}
                             label={this.props.translate("popUp.forward.commentLabel")}
                             labelState={`(${this.props.translate("popUp.required")})`}
                    />
                </div>
                <div className="modal-footer">
                    <div className="d-flex gap-8 float-right">
                        <Button type={ButtonType.PRIMARY}
                                onClick={this.ok}
                                tabIndex={TAB_INDEX+2}
                                disabled={!okEnabled}
                                text={this.props.translate("popUp.ok")}
                        />
                        <Button type={ButtonType.SECONDARY}
                                onClick={this.props.closeCallback}
                                tabIndex={TAB_INDEX+3}
                                onBlur={this.focusFirst}
                                text={this.props.translate("popUp.cancel")}
                        />
                    </div>
                </div>
            </div>

        );
    }

    getType() {
        return TASK_ACTIONS.REASSIGN;
    }

}

SendForward.propTypes = {
    tasks: PropTypes.array, // selected tasks
    closeCallback: PropTypes.func, //callback for closing the popup
    translate: PropTypes.func, // to translate texts
    showNotification: PropTypes.func, // to show transient notification

};
const withTranslations = translate(SendForward);
export default withTranslations;
